export default function ValidateName(Name, rfvNameId) {
  if (!rfvNameId) {
    rfvNameId = "#FirstNameRequired";
  }
  var valid = true;
  var rfvName = Name.siblings(rfvNameId);
  rfvName.hide();
  Name.removeClass("error");
  if ($.trim(Name.val()).length == 0) {
    valid = false;
    rfvName.show();
    Name.addClass("error");
  }
  return valid;
}